import React, { useEffect } from "react";

// import HomeNavbar from "components/Navbar/HomeNavbar.jsx";
import HomeNavbar from "../../components/Navbar/HomeNavbar";
import ParticleEffect from "../../components/ParticleEffect/ParticleEffect";
import YSMLogo from "../../assets/ysm-shield.png";

import "./HomePage.css";

const Home = () => {
	useEffect(() => {
		// when the component mounts, disable scrolling and set the background color
		document.body.classList.add("disable-scroll");
		document.body.style.backgroundColor = "rgb(0, 53, 107)";

		// when the component unmounts, re-enable scrolling and revert the background color
		return () => {
			document.body.classList.remove("disable-scroll");
		};
	}, []);

	return (
		<>
			<HomeNavbar />
			<ParticleEffect />
			<div className="main-text">
				<img className="ysm-img" src={YSMLogo} alt="ysm-shield" />
				<div className="heading-text">
					{"\u00A0"}
					{"\u00A0"}Welcome to Seo Laboratory
				</div>
				<div className="university-text">Yale University</div>
			</div>
		</>
	);
};

export default Home;
